// import { ActionNotification, Notification, NotificationType } from '../../types/NotificationTypes';
// import { AppDispatch, RootState } from '../../redux/store/store';
// import React, { useEffect, useRef, useState } from 'react';
// import { differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds, differenceInWeeks, parseISO } from 'date-fns';
// import { fetchAllNotifications, markNotificationAsRead } from '../../redux/slices/notificationSlice';
// import { useDispatch, useSelector } from 'react-redux';

// import Badge from '@mui/material/Badge';
// import { Button } from 'primereact/button';
// import { Card } from 'primereact/card';
// import { Dialog } from 'primereact/dialog';
// import { IconButton } from '@mui/material';
// import NotificationsIcon from '@mui/icons-material/Notifications';
// import { OverlayPanel } from 'primereact/overlaypanel';
// import { RTU } from '../../types/RTU';
// import { ScrollPanel } from 'primereact/scrollpanel';
// import { TabMenu } from 'primereact/tabmenu';
// import { Toast } from 'primereact/toast';
// import { useNavigate } from 'react-router-dom';

// // import { Badge } from 'primereact/badge';





// const NotificationsView = () => {
//     const op = useRef<OverlayPanel>(null);
//     const toast = useRef(null);
//     const [activeIndex, setActiveIndex] = useState(0);
//     const [selectedNotification, setSelectedNotification] = useState<Notification>();
//     const [dialogVisible, setDialogVisible] = useState(false);
//     const dispatch = useDispatch<AppDispatch>();
//     const notifications = useSelector((state: RootState) => state.notifications.notifications);
//     const rtus = useSelector((state: RootState) => state.rtu.rtus);
//     const navigate = useNavigate(); // Hook for navigation

//     useEffect(() => {
//         dispatch(fetchAllNotifications());
//     }, [dispatch]);

//     const unreadCount = notifications.filter(n => !n.read).length;

//     const items = [
//         { label: 'All', icon: 'pi pi-fw pi-list' },
//         { label: 'Actions', icon: 'pi pi-fw pi-cog' },
//         { label: 'Alarms', icon: 'pi pi-fw pi-bell' }
//     ];

//     const handleNotificationClick = (notification: Notification) => {
//         setSelectedNotification(notification);
//         setDialogVisible(true);
//             // Close the notification panel
//         // op.current?.hide();
//         if (!notification.read) {
//             dispatch(markNotificationAsRead({ id: notification.id, notificationType: notification.type }));
//             // toast.current.show({ severity: 'success', summary: 'Marked as read', detail: notification.message });
//         }
//     };

//     const handleMarkAllAsRead = () => {
//         // Dispatch action to mark all notifications as read
//         notifications.forEach(notification => {
//           if (!notification.read) {
//             dispatch(markNotificationAsRead({ id: notification.id, notificationType: notification.type }));
//           }
//         });
//         // Optionally show a toast or feedback that all are marked as read
//       };

//       // Helper function to get relative time
//       const getRelativeTime = (timestamp: string) => {
//         const now = new Date();
//         const timeNotification = parseISO(timestamp);
//         const secondsDiff = differenceInSeconds(now, timeNotification);
//         if (secondsDiff < 60) return `${secondsDiff} seconds ago`;
//         const minutesDiff = differenceInMinutes(now, timeNotification);
//         if (minutesDiff < 60) return `${minutesDiff} minutes ago`;
//         const hoursDiff = differenceInHours(now, timeNotification);
//         if (hoursDiff < 24) return `${hoursDiff} hours ago`;
//         const daysDiff = differenceInDays(now, timeNotification);
//         if (daysDiff < 7) return `${daysDiff} days ago`;
//         const weeksDiff = differenceInWeeks(now, timeNotification);
//         return `${weeksDiff} weeks ago`;
//       };

//       const sortedNotifications = notifications.slice().sort((a, b) => {
//         return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
//     });

//     const MAX_MESSAGE_LENGTH = 50; // Maximum number of characters to display

//     // const renderNotificationCard = (notification: Notification) => {
//     //     const isActionNotification = notification.type === NotificationType.ACTION;
//     //     const isSuccess = notification.status === 'success';
//     //     const avatarIcon = isSuccess ? 'pi pi-check-circle' : 'pi pi-times-circle';
//     //     const avatarColor = isSuccess ? 'green' : 'red';
    
//     //     let message = '';

//     //     // Check if the notification is an action notification and create a message accordingly
//     //     if (isActionNotification) {
//     //         const actionNotification = notification as ActionNotification;
//     //         switch (actionNotification.actionType) {
//     //             case 'reboot':
//     //                 message = `Reboot ${isSuccess ? 'succeeded' : 'failed'}`;
//     //                 break;
//     //             case 'updateConfig':
//     //                 message = `Update Config ${isSuccess ? 'succeeded' : 'failed'}`;
//     //                 break;
//     //             case 'updateDeploy':
//     //                 message = `Update Deployment ${isSuccess ? 'succeeded' : 'failed'}`;
//     //                 break;
//     //             default:
//     //                 message = `Action ${isSuccess ? 'succeeded' : 'failed'}`;
//     //                 break;
//     //         }
//     //     } else {
//     //         // For other types of notifications, use a generic message or handle differently
//     //         message = notification.message;
//     //     }

//     //     // Find the matching RTU if the notification is an action
//     //     let rtuId = '';
//     //     let matchingRTU;
//     //     if (isActionNotification) {
//     //         matchingRTU = rtus.find(rtu => rtu.publicIPAddress === notification.ip);
//     //         rtuId = matchingRTU ? `RTU ID: ${matchingRTU.id}` : 'RTU ID: Unknown';
//     //     }
    
//     //     // Truncate the message if it's too long
//     //     const displayMessage = notification.message.length > MAX_MESSAGE_LENGTH
//     //         ? `${notification.message.substring(0, MAX_MESSAGE_LENGTH)}...`
//     //         : notification.message;
    
//     //     return (
//     //         <Card
//     //             key={notification.id}
//     //             style={{ margin: '0.5em', borderColor: notification.read ? '#ccc' : '#007ad9', position: 'relative' }}
//     //             className={`p-shadow-4 ${notification.read ? 'read-notification' : 'unread-notification'}`}
//     //             onClick={() => handleNotificationClick(notification)}
//     //         >
//     //             <div style={{ display: 'flex', alignItems: 'center' }}>
//     //                 <i className={`${avatarIcon}`} style={{ color: avatarColor, fontSize: '1.5rem', marginRight: '0.5rem' }}></i>
//     //                 <div style={{ flex: 1 }}>
//     //                     <p style={{ fontWeight: notification.read ? 'normal' : 'bold' }}>{message}</p>
//     //                     {isActionNotification && <small style={{ display: 'block', color: '#888' }}>{rtuId}</small>}
//     //                 </div>
//     //             </div>
//     //             <div style={{ position: 'absolute', bottom: '10px', right: '10px', fontSize: '0.75rem' }}>
//     //                 {getRelativeTime(notification.timestamp)}
//     //             </div>
//     //         </Card>
//     //     );
//     // };
    
    
//     const renderNotificationCard = (notification: Notification) => {
//       const isActionNotification = notification.type === NotificationType.ACTION;
//       const isSuccess = notification.status === 'success';
//       const isStarted = notification.status === 'started';
//       const avatarIcon = isSuccess ? 'pi pi-check-circle' : isStarted ? 'pi pi-refresh' : 'pi pi-times-circle';
//       const avatarColor = isSuccess ? 'green' : isStarted ? 'blue' : 'red';
  
//       let message = '';
  
//       // Check if the notification is an action notification and create a message accordingly
//       if (isActionNotification) {
//           const actionNotification = notification as ActionNotification;
//           switch (actionNotification.actionType) {
//               case 'reboot':
//                   message = `Reboot ${isSuccess ? 'succeeded' : isStarted ? 'started' : 'failed'}`;
//                   break;
//               case 'updateConfig':
//                   message = `Update Config ${isSuccess ? 'succeeded' : isStarted ? 'started' : 'failed'}`;
//                   break;
//               case 'updateDeploy':
//                   message = `Update Deployment ${isSuccess ? 'succeeded' : isStarted ? 'started' : 'failed'}`;
//                   break;
//               default:
//                   message = `Action ${isSuccess ? 'succeeded' : isStarted ? 'started' : 'failed'}`;
//                   break;
//           }
//       } else {
//           // For other types of notifications, use a generic message or handle differently
//           message = notification.message;
//       }
  
//       // Find the matching RTU if the notification is an action
//       let rtuId = '';
//       let matchingRTU;
//       if (isActionNotification) {
//           matchingRTU = rtus.find(rtu => rtu.publicIPAddress === notification.ip);
//           rtuId = matchingRTU ? `RTU ID: ${matchingRTU.id}` : 'RTU ID: Unknown';
//       }
  
//       // Truncate the message if it's too long
//       const displayMessage = notification.message.length > MAX_MESSAGE_LENGTH
//           ? `${notification.message.substring(0, MAX_MESSAGE_LENGTH)}...`
//           : notification.message;
  
//       return (
//           <Card
//               key={notification.id}
//               style={{ margin: '0.5em', borderColor: notification.read ? '#ccc' : '#007ad9', position: 'relative' }}
//               className={`p-shadow-4 ${notification.read ? 'read-notification' : 'unread-notification'}`}
//               onClick={() => handleNotificationClick(notification)}
//           >
//               <div style={{ display: 'flex', alignItems: 'center' }}>
//                   <i className={`${avatarIcon}`} style={{ color: avatarColor, fontSize: '1.5rem', marginRight: '0.5rem' }}></i>
//                   <div style={{ flex: 1 }}>
//                       <p style={{ fontWeight: notification.read ? 'normal' : 'bold' }}>{message}</p>
//                       {isActionNotification && <small style={{ display: 'block', color: '#888' }}>{rtuId}</small>}
//                   </div>
//               </div>
//               <div style={{ position: 'absolute', bottom: '10px', right: '10px', fontSize: '0.75rem' }}>
//                   {getRelativeTime(notification.timestamp)}
//               </div>
//           </Card>
//       );
//   };
  
//     const renderNotificationDetails = (notification: Notification) => {
//         // Check if it's an action notification to render specific details
//         const isActionNotification = notification.type === NotificationType.ACTION;
//         let rtuId:any = null;
//         let rtuName = 'Unknown';
//         let matchingRTU: any;
//         // Assuming you can derive the RTU ID and name from the notification object
//         // Or replace with your own logic to fetch the RTU details
//         if (isActionNotification) {
//             const matchingRTU = rtus.find(rtu => rtu.publicIPAddress === notification.ip);
//             rtuId = matchingRTU ? matchingRTU.id : 'Unknown';
//             rtuName = matchingRTU ? matchingRTU.name : 'Unknown';
//         }

//         const handleRTUClick = () => {
//             // Navigate only if we have a valid RTU ID
//             if (rtuId !== 'Unknown') {
//               navigate(`/rtupage/${rtuId}`, { state: { rtu: matchingRTU } });
//               setDialogVisible(false)
//             }
//           };

//         return (
//           <div>
//             <h4 style={{ fontWeight: 'bold', marginBottom: '1rem' }}>{notification.message}</h4>
//             {isActionNotification && (
//                 <div style={{ marginBottom: '0.5rem', cursor: 'pointer', color: '#007ad9' }} onClick={handleRTUClick}>
//                 <strong>RTU:</strong> {rtuId} - {rtuName}
//                 </div>
//             )}
//             {isActionNotification && (
//               <div style={{ marginBottom: '0.5rem' }}>
//                 <strong>Action Type:</strong> {(notification as ActionNotification).actionType}
//               </div>
//             )}
//             <div style={{ marginBottom: '0.5rem' }}>
//               <strong>Status:</strong> <span style={{ color: notification.status === 'success' ? 'green' : 'red' }}>{notification.status}</span>
//             </div>
//             {notification.ip && (
//               <div style={{ marginBottom: '0.5rem' }}>
//                 <strong>IP Address:</strong> {notification.ip}
//               </div>
//             )}
//             <div style={{ marginBottom: '0.5rem' }}>
//               <strong>Time:</strong> {new Date(notification.timestamp).toLocaleString()}
//             </div>
//             {/* {isActionNotification && (
//               // Assuming you might have a way to handle these actions, like a function that takes an action type
//               <Button label="Take Action" className="p-button-primary" onClick={() => handleNotificationAction(notification)} />
//             )} */}
//           </div>
//         );
//       };


//     return (
//         <div>
//             {/* <Button type="button" icon="pi pi-bell" badge={unreadCount} onClick={(e) => op.current?.toggle(e)} aria-haspopup aria-controls="overlay_panel" /> */}
//             <IconButton 
//                 // type="button" 
//                 onClick={(e) => op.current?.toggle(e)} 
//                 aria-haspopup 
//                 aria-controls="overlay_panel"
//                 className="p-button-rounded p-button-info" // You can still use PrimeReact styles for the button if you wish
//             >

//                 <Badge  badgeContent={unreadCount} color="info">
//                 <NotificationsIcon style={{ color: 'white' }} />

//                 </Badge>
//             </IconButton>
   
//       <OverlayPanel ref={op} id="overlay_panel" style={{ width: '450px' }}>
//         <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
//         <ScrollPanel style={{ width: '100%', height: '400px' }}>
//           {/* Include a "Mark all as read" button */}
//           {unreadCount > 0 && (
//             <Button label="Mark all as read" icon="pi pi-check" onClick={handleMarkAllAsRead} className="p-button-text" />
//           )}
//           {/* If there are no notifications, show a message */}
//           {notifications.length === 0 ? (
//             <div className="p-text-center">No new notifications</div>
//           ) : (
//             <div>
//               {activeIndex === 0 && sortedNotifications.map(renderNotificationCard)}
//               {activeIndex === 1 && sortedNotifications.filter(n => n.type === NotificationType.ACTION).map(renderNotificationCard)}
//               {activeIndex === 2 && sortedNotifications.filter(n => n.type === NotificationType.SYSTEM_EVENT).map(renderNotificationCard)}
//             </div>
//           )}
//         </ScrollPanel>
//       </OverlayPanel>

//             <Toast ref={toast} />

//             {selectedNotification && (
//                 <Dialog
//                     header="Notification Details"
//                     visible={dialogVisible}
//                     modal
//                     onHide={() => setDialogVisible(false)}
//                     breakpoints={{ '960px': '75vw', '640px': '100vw' }} // Example breakpoints for responsive design
//                     style={{ width: '50vw' }}
//                 >
//                     {renderNotificationDetails(selectedNotification)}
//                 </Dialog>
//             )}

//         </div>
//     );
// };

// export default NotificationsView;

import  {useRef, useState} from 'react';

import Badge from '@mui/material/Badge';
import { IconButton } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ScrollPanel } from 'primereact/scrollpanel';
import { TabMenu } from 'primereact/tabmenu';
import Tooltip from '@mui/material/Tooltip';
import { useLocation } from 'react-router-dom';

const NotificationsView = () => {
    const op = useRef<OverlayPanel>(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const { pathname } = useLocation();
    const isStandalonePage = pathname === '/notifications';

    const items = [
        { label: 'Actions', icon: 'pi pi-fw pi-cog' },
        { label: 'Alarms', icon: 'pi pi-fw pi-bell' }
    ];

    const trigger = (
      <Tooltip title="Notifications" arrow>
        <IconButton
            onClick={(e) => op.current?.toggle(e)}
            aria-haspopup
            aria-controls="overlay_panel"
            aria-label="Open notification preview"
            className="p-button-rounded p-button-info"
            style={{
                width: isStandalonePage ? '2.25rem' : '2rem',
                height: isStandalonePage ? '2.25rem' : '2rem',
                background: isStandalonePage ? '#cf0000' : 'transparent',
                color: isStandalonePage ? '#fff' : '#20313f',
            }}
        >
            <Badge badgeContent={0} color="info">
                <NotificationsIcon style={{ color: isStandalonePage ? 'white' : '#20313f' }} />
            </Badge>
        </IconButton>
      </Tooltip>
    );

    const overlay = (
        <OverlayPanel ref={op} id="overlay_panel" style={{ width: 'min(28rem, calc(100vw - 2rem))' }}>
            <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
            <ScrollPanel style={{ width: '100%', height: '200px' }}>
                <div className="p-text-center" style={{ padding: '1.25rem 0.75rem', color: '#526173' }}>
                    This feature will be implemented soon.
                </div>
            </ScrollPanel>
        </OverlayPanel>
    );

    if (!isStandalonePage) {
        return (
            <>
                {trigger}
                {overlay}
            </>
        );
    }

    return (
        <div style={{ padding: '0.75rem' }}>
            <section
                className="flat-card"
                style={{
                    display: 'grid',
                    gap: '0.75rem',
                    maxWidth: '32rem',
                    padding: '1rem',
                    border: '1px solid #dde6ef',
                    borderRadius: '8px',
                    background: '#fff',
                }}
            >
                <div>
                    <h3 style={{ margin: '0 0 0.25rem', fontSize: '1rem' }}>Notification preview</h3>
                    <p style={{ margin: 0, color: '#526173', fontSize: '0.86rem' }}>
                        Live notifications are not enabled yet. Use this preview to verify the notification panel shell.
                    </p>
                </div>
                <div style={{ justifySelf: 'start' }}>{trigger}</div>
            </section>

            {overlay}
        </div>
    );
};

export default NotificationsView;
